// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2IXy_","alertIcon":"ConfirmModal_alertIcon__16Hb8"};